<input
  class="numeric-input"
  type="number"
  [attr.id]="controlId"
  [value]="value"
  [min]="min"
  [max]="max"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [class.form-error-border]="error"
  (input)="handleInput($event)" />
